var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _circle, _path224, _path225, _path226, _path227, _path228, _path229, _polygon, _polygon2, _polygon3, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlonehere(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "841.9px",
    height: "595.3px",
    viewBox: "0 0 841.9 595.3",
    enableBackground: "new 0 0 841.9 595.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.945,
    y1: 1029.0713,
    x2: 420.945,
    y2: 220.5597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#SVGID_1_)",
    width: 841.9,
    height: 595.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 722.6473,
    cy: 63.1195,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M722.6,65.6c3.2,0,3.2-5,0-5C719.4,60.6,719.4,65.6,722.6,65.6L722.6,65.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 793.1437,
    cy: 37.6208,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M793.1,40.1c3.2,0,3.2-5,0-5S789.9,40.1,793.1,40.1L793.1,40.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 343.1662,
    cy: 34.621,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M343.2,37.1c3.2,0,3.2-5,0-5C339.9,32.1,339.9,37.1,343.2,37.1L343.2,37.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 226.1721,
    cy: 84.1185,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M226.2,86.6c3.2,0,3.2-5,0-5S222.9,86.6,226.2,86.6L226.2,86.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 116.6776,
    cy: 18.1218,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M116.7,20.6c3.2,0,3.2-5,0-5C113.5,15.6,113.5,20.6,116.7,20.6L116.7,20.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 82.1793,
    cy: 72.1191,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M82.2,74.6c3.2,0,3.2-5,0-5S79,74.6,82.2,74.6L82.2,74.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 28.182,
    cy: 49.6202,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M28.2,52.1c3.2,0,3.2-5,0-5S25,52.1,28.2,52.1L28.2,52.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 77.6795,
    cy: 27.1213,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M77.7,29.6c3.2,0,3.2-5,0-5S74.5,29.6,77.7,29.6L77.7,29.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 44.6812,
    cy: 94.618,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M44.7,97.1c3.2,0,3.2-5,0-5S41.5,97.1,44.7,97.1L44.7,97.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 29.6819,
    cy: 153.1151,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M29.7,155.6c3.2,0,3.2-5,0-5S26.5,155.6,29.7,155.6L29.7,155.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 32.6818,
    cy: 229.6112,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M32.7,232.1c3.2,0,3.2-5,0-5S29.5,232.1,32.7,232.1L32.7,232.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 44.6812,
    cy: 282.1086,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M44.7,284.6c3.2,0,3.2-5,0-5S41.5,284.6,44.7,284.6L44.7,284.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 134.6767,
    cy: 210.1122,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M134.7,212.6c3.2,0,3.2-5,0-5C131.5,207.6,131.5,212.6,134.7,212.6L134.7,212.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 86.6791,
    cy: 184.6135,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M86.7,187.1c3.2,0,3.2-5,0-5S83.5,187.1,86.7,187.1L86.7,187.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 152.6758,
    cy: 93.118,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M152.7,95.6c3.2,0,3.2-5,0-5C149.5,90.6,149.5,95.6,152.7,95.6L152.7,95.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 275.6696,
    cy: 57.1198,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M275.7,59.6c3.2,0,3.2-5,0-5S272.4,59.6,275.7,59.6L275.7,59.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 209.6729,
    cy: 15.1219,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M209.7,17.6c3.2,0,3.2-5,0-5C206.4,12.6,206.4,17.6,209.7,17.6L209.7,17.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 191.6738,
    cy: 115.6169,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M191.7,118.1c3.2,0,3.2-5,0-5S188.4,118.1,191.7,118.1L191.7,118.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 190.1739,
    cy: 249.1102,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M190.2,251.6c3.2,0,3.2-5,0-5S186.9,251.6,190.2,251.6L190.2,251.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 146.6761,
    cy: 156.1149,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M146.7,158.6c3.2,0,3.2-5,0-5C143.5,153.6,143.5,158.6,146.7,158.6L146.7,158.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 89.6789,
    cy: 123.1165,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M89.7,125.6c3.2,0,3.2-5,0-5C86.5,120.6,86.5,125.6,89.7,125.6L89.7,125.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: 158.6755,
    cy: 31.6211,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M158.7,34.1c3.2,0,3.2-5,0-5C155.5,29.1,155.5,34.1,158.7,34.1L158.7,34.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: 22.1823,
    cy: 348.1053,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M22.2,350.6c3.2,0,3.2-5,0-5S19,350.6,22.2,350.6L22.2,350.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_25_",
    cx: 101.6783,
    cy: 294.108,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M101.7,296.6c3.2,0,3.2-5,0-5S98.5,296.6,101.7,296.6L101.7,296.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_26_",
    cx: 209.6729,
    cy: 157.6148,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M209.7,160.1c3.2,0,3.2-5,0-5C206.4,155.1,206.4,160.1,209.7,160.1L209.7,160.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_27_",
    cx: 47.681,
    cy: 12.1221,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M47.7,13.6c1.9,0,1.9-3,0-3S45.7,13.6,47.7,13.6L47.7,13.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_28_",
    cx: 59.6804,
    cy: 57.1198,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_28_)",
    d: "M59.7,58.6c1.9,0,1.9-3,0-3S57.7,58.6,59.7,58.6L59.7,58.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_29_",
    cx: 17.6825,
    cy: 85.6184,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M17.7,87.1c1.9,0,1.9-3,0-3S15.7,87.1,17.7,87.1L17.7,87.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_30_",
    cx: 28.182,
    cy: 102.1176,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M28.2,103.6c1.9,0,1.9-3,0-3S26.2,103.6,28.2,103.6L28.2,103.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_31_",
    cx: 40.1814,
    cy: 69.1192,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_31_)",
    d: "M40.2,70.6c1.9,0,1.9-3,0-3S38.2,70.6,40.2,70.6L40.2,70.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_32_",
    cx: 62.6803,
    cy: 118.6168,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M62.7,120.1c1.9,0,1.9-3,0-3S60.7,120.1,62.7,120.1L62.7,120.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_33_",
    cx: 11.6828,
    cy: 138.1158,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_33_)",
    d: "M11.7,139.6c1.9,0,1.9-3,0-3S9.7,139.6,11.7,139.6L11.7,139.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_34_",
    cx: 13.1827,
    cy: 189.1133,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_34_)",
    d: "M13.2,190.6c1.9,0,1.9-3,0-3S11.2,190.6,13.2,190.6L13.2,190.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_35_",
    cx: 56.6806,
    cy: 175.6139,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_35_)",
    d: "M56.7,177.1c1.9,0,1.9-3,0-3S54.7,177.1,56.7,177.1L56.7,177.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_36_",
    cx: 109.1779,
    cy: 81.1186,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_36_)",
    d: "M109.2,82.6c1.9,0,1.9-3,0-3C107.2,79.6,107.2,82.6,109.2,82.6L109.2,82.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_37_",
    cx: 133.1767,
    cy: 52.6201,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_37_)",
    d: "M133.2,54.1c1.9,0,1.9-3,0-3S131.2,54.1,133.2,54.1L133.2,54.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_38_",
    cx: 187.174,
    cy: 79.6187,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M187.2,81.1c1.9,0,1.9-3,0-3S185.2,81.1,187.2,81.1L187.2,81.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_39_",
    cx: 176.6746,
    cy: 12.1221,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_39_)",
    d: "M176.7,13.6c1.9,0,1.9-3,0-3S174.7,13.6,176.7,13.6L176.7,13.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_40_",
    cx: 155.6756,
    cy: 21.1216,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M155.7,22.6c1.9,0,1.9-3,0-3S153.7,22.6,155.7,22.6L155.7,22.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_41_",
    cx: 293.6687,
    cy: 22.6216,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_41_)",
    d: "M293.7,24.1c1.9,0,1.9-3,0-3C291.7,21.1,291.7,24.1,293.7,24.1L293.7,24.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_42_",
    cx: 244.1712,
    cy: 36.1209,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_42_)",
    d: "M244.2,37.6c1.9,0,1.9-3,0-3S242.2,37.6,244.2,37.6L244.2,37.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_43_",
    cx: 196.1736,
    cy: 49.6202,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_43_)",
    d: "M196.2,51.1c1.9,0,1.9-3,0-3C194.2,48.1,194.2,51.1,196.2,51.1L196.2,51.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_44_",
    cx: 242.6713,
    cy: 84.1185,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_44_)",
    d: "M242.7,85.6c1.9,0,1.9-3,0-3S240.7,85.6,242.7,85.6L242.7,85.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_45_",
    cx: 227.672,
    cy: 52.6201,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_45_)",
    d: "M227.7,54.1c1.9,0,1.9-3,0-3S225.7,54.1,227.7,54.1L227.7,54.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_46_",
    cx: 326.6671,
    cy: 48.1203,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_46_)",
    d: "M326.7,49.6c1.9,0,1.9-3,0-3S324.7,49.6,326.7,49.6L326.7,49.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_47_",
    cx: 235.1716,
    cy: 115.6169,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_47_)",
    d: "M235.2,117.1c1.9,0,1.9-3,0-3C233.2,114.1,233.2,117.1,235.2,117.1L235.2,117.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_48_",
    cx: 226.1721,
    cy: 144.1155,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_48_)",
    d: "M226.2,145.6c1.9,0,1.9-3,0-3S224.2,145.6,226.2,145.6L226.2,145.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_49_",
    cx: 161.6753,
    cy: 123.1165,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_49_)",
    d: "M161.7,124.6c1.9,0,1.9-3,0-3C159.7,121.6,159.7,124.6,161.7,124.6L161.7,124.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_50_",
    cx: 124.1772,
    cy: 111.1171,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_50_)",
    d: "M124.2,112.6c1.9,0,1.9-3,0-3C122.2,109.6,122.2,112.6,124.2,112.6L124.2,112.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_51_",
    cx: 163.1752,
    cy: 63.1195,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_51_)",
    d: "M163.2,64.6c1.9,0,1.9-3,0-3C161.2,61.6,161.2,64.6,163.2,64.6L163.2,64.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_52_",
    cx: 92.6788,
    cy: 141.1156,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_52_)",
    d: "M92.7,142.6c1.9,0,1.9-3,0-3C90.7,139.6,90.7,142.6,92.7,142.6L92.7,142.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_53_",
    cx: 119.6774,
    cy: 168.1143,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_53_)",
    d: "M119.7,169.6c1.9,0,1.9-3,0-3S117.7,169.6,119.7,169.6L119.7,169.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_54_",
    cx: 175.1746,
    cy: 192.1131,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_54_)",
    d: "M175.2,193.6c1.9,0,1.9-3,0-3S173.2,193.6,175.2,193.6L175.2,193.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_55_",
    cx: 181.1743,
    cy: 135.116,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_55_)",
    d: "M181.2,136.6c1.9,0,1.9-3,0-3C179.2,133.6,179.2,136.6,181.2,136.6L181.2,136.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_56_",
    cx: 133.1767,
    cy: 231.1111,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_56_)",
    d: "M133.2,232.6c1.9,0,1.9-3,0-3S131.2,232.6,133.2,232.6L133.2,232.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_57_",
    cx: 109.1779,
    cy: 208.6123,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_57_)",
    d: "M109.2,210.1c1.9,0,1.9-3,0-3C107.2,207.1,107.2,210.1,109.2,210.1L109.2,210.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_58_",
    cx: 77.6795,
    cy: 225.1115,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_58_)",
    d: "M77.7,226.6c1.9,0,1.9-3,0-3C75.7,223.6,75.7,226.6,77.7,226.6L77.7,226.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_59_",
    cx: 49.1809,
    cy: 202.6126,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_59_)",
    d: "M49.2,204.1c1.9,0,1.9-3,0-3S47.2,204.1,49.2,204.1L49.2,204.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_60_",
    cx: 50.6809,
    cy: 241.6106,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_60_)",
    d: "M50.7,243.1c1.9,0,1.9-3,0-3S48.7,243.1,50.7,243.1L50.7,243.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_61_",
    cx: 20.6824,
    cy: 265.6094,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_61_)",
    d: "M20.7,267.1c1.9,0,1.9-3,0-3S18.7,267.1,20.7,267.1L20.7,267.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_62_",
    cx: 14.6827,
    cy: 297.1078,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_62_)",
    d: "M14.7,298.6c1.9,0,1.9-3,0-3S12.7,298.6,14.7,298.6L14.7,298.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_63_",
    cx: 13.1827,
    cy: 387.1033,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_63_)",
    d: "M13.2,388.6c1.9,0,1.9-3,0-3S11.2,388.6,13.2,388.6L13.2,388.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_64_",
    cx: 62.6803,
    cy: 327.1064,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_64_)",
    d: "M62.7,328.6c1.9,0,1.9-3,0-3S60.7,328.6,62.7,328.6L62.7,328.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_65_",
    cx: 76.1796,
    cy: 259.6097,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_65_)",
    d: "M76.2,261.1c1.9,0,1.9-3,0-3C74.2,258.1,74.2,261.1,76.2,261.1L76.2,261.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_66_",
    cx: 143.6762,
    cy: 249.1102,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_66_)",
    d: "M143.7,250.6c1.9,0,1.9-3,0-3C141.7,247.6,141.7,250.6,143.7,250.6L143.7,250.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_67_",
    cx: 13.1827,
    cy: 219.1117,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_67_)",
    d: "M13.2,220.6c1.9,0,1.9-3,0-3S11.2,220.6,13.2,220.6L13.2,220.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_68_",
    cx: 101.6783,
    cy: 253.61,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_68_)",
    d: "M101.7,255.1c1.9,0,1.9-3,0-3C99.7,252.1,99.7,255.1,101.7,255.1L101.7,255.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_69_",
    cx: 83.6792,
    cy: 307.6073,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_69_)",
    d: "M83.7,309.1c1.9,0,1.9-3,0-3C81.7,306.1,81.7,309.1,83.7,309.1L83.7,309.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_70_",
    cx: 197.6735,
    cy: 217.6118,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_70_)",
    d: "M197.7,219.1c1.9,0,1.9-3,0-3C195.7,216.1,195.7,219.1,197.7,219.1L197.7,219.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_71_",
    cx: 163.1752,
    cy: 228.1113,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_71_)",
    d: "M163.2,229.6c1.9,0,1.9-3,0-3C161.2,226.6,161.2,229.6,163.2,229.6L163.2,229.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_72_",
    cx: 229.1719,
    cy: 193.613,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_72_)",
    d: "M229.2,195.1c1.9,0,1.9-3,0-3S227.2,195.1,229.2,195.1L229.2,195.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_73_",
    cx: 349.166,
    cy: 67.6193,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_73_)",
    d: "M349.2,69.1c1.9,0,1.9-3,0-3C347.2,66.1,347.2,69.1,349.2,69.1L349.2,69.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_74_",
    cx: 287.669,
    cy: 85.6184,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_74_)",
    d: "M287.7,87.1c1.9,0,1.9-3,0-3S285.7,87.1,287.7,87.1L287.7,87.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_75_",
    cx: 269.6699,
    cy: 136.6159,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_75_)",
    d: "M269.7,138.1c1.9,0,1.9-3,0-3S267.7,138.1,269.7,138.1L269.7,138.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_76_",
    cx: 265.1701,
    cy: 114.117,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_76_)",
    d: "M265.2,115.6c1.9,0,1.9-3,0-3S263.2,115.6,265.2,115.6L265.2,115.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_77_",
    cx: 317.6675,
    cy: 94.618,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_77_)",
    d: "M317.7,96.1c1.9,0,1.9-3,0-3S315.7,96.1,317.7,96.1L317.7,96.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_78_",
    cx: 379.1644,
    cy: 39.1207,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_78_)",
    d: "M379.2,40.6c1.9,0,1.9-3,0-3S377.2,40.6,379.2,40.6L379.2,40.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_79_",
    cx: 454.1607,
    cy: 16.6219,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_79_)",
    d: "M454.2,18.1c1.9,0,1.9-3,0-3C452.2,15.1,452.2,18.1,454.2,18.1L454.2,18.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_80_",
    cx: 317.6675,
    cy: 9.1222,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_80_)",
    d: "M317.7,10.6c1.9,0,1.9-3,0-3S315.7,10.6,317.7,10.6L317.7,10.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_81_",
    cx: 298.1685,
    cy: 52.6201,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_81_)",
    d: "M298.2,54.1c1.9,0,1.9-3,0-3S296.2,54.1,298.2,54.1L298.2,54.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_82_",
    cx: 260.6703,
    cy: 21.1216,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_82_)",
    d: "M260.7,22.6c1.9,0,1.9-3,0-3C258.7,19.6,258.7,22.6,260.7,22.6L260.7,22.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_83_",
    cx: 146.6761,
    cy: 274.609,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_83_)",
    d: "M146.7,276.1c1.9,0,1.9-3,0-3C144.7,273.1,144.7,276.1,146.7,276.1L146.7,276.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_84_",
    cx: 113.6777,
    cy: 352.6051,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_84_)",
    d: "M113.7,354.1c1.9,0,1.9-3,0-3C111.7,351.1,111.7,354.1,113.7,354.1L113.7,354.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_85_",
    cx: 56.6806,
    cy: 373.604,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_85_)",
    d: "M56.7,375.1c1.9,0,1.9-3,0-3S54.7,375.1,56.7,375.1L56.7,375.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_86_",
    cx: 473.6597,
    cy: 40.6207,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_86_)",
    d: "M473.7,42.1c1.9,0,1.9-3,0-3C471.7,39.1,471.7,42.1,473.7,42.1L473.7,42.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_87_",
    cx: 550.1559,
    cy: 42.1206,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_87_)",
    d: "M550.2,43.6c1.9,0,1.9-3,0-3C548.2,40.6,548.2,43.6,550.2,43.6L550.2,43.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_88_",
    cx: 646.1511,
    cy: 63.1195,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_88_)",
    d: "M646.2,64.6c1.9,0,1.9-3,0-3C644.2,61.6,644.2,64.6,646.2,64.6L646.2,64.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_89_",
    cx: 605.6531,
    cy: 124.6165,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_89_)",
    d: "M605.7,126.1c1.9,0,1.9-3,0-3C603.7,123.1,603.7,126.1,605.7,126.1L605.7,126.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_90_",
    cx: 725.6471,
    cy: 165.1144,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_90_)",
    d: "M725.6,166.6c1.9,0,1.9-3,0-3C723.7,163.6,723.7,166.6,725.6,166.6L725.6,166.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_91_",
    cx: 797.6435,
    cy: 103.6175,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_91_)",
    d: "M797.6,105.1c1.9,0,1.9-3,0-3C795.7,102.1,795.7,105.1,797.6,105.1L797.6,105.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_92_",
    cx: 685.1492,
    cy: 18.1218,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_92_)",
    d: "M685.1,19.6c1.9,0,1.9-3,0-3C683.2,16.6,683.2,19.6,685.1,19.6L685.1,19.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_93_",
    cx: 589.1539,
    cy: 72.1191,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_93_)",
    d: "M589.2,73.6c1.9,0,1.9-3,0-3C587.2,70.6,587.2,73.6,589.2,73.6L589.2,73.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_94_",
    cx: 433.1617,
    cy: 94.618,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_94_)",
    d: "M433.2,96.1c1.9,0,1.9-3,0-3S431.2,96.1,433.2,96.1L433.2,96.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_95_",
    cx: 377.6645,
    cy: 150.1152,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_95_)",
    d: "M377.7,151.6c1.9,0,1.9-3,0-3S375.7,151.6,377.7,151.6L377.7,151.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_96_",
    cx: 346.1661,
    cy: 108.1173,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_96_)",
    d: "M346.2,109.6c1.9,0,1.9-3,0-3C344.2,106.6,344.2,109.6,346.2,109.6L346.2,109.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_97_",
    cx: 304.1682,
    cy: 205.6124,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_97_)",
    d: "M304.2,207.1c1.9,0,1.9-3,0-3S302.2,207.1,304.2,207.1L304.2,207.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_98_",
    cx: 311.6678,
    cy: 153.1151,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_98_)",
    d: "M311.7,154.6c1.9,0,1.9-3,0-3S309.7,154.6,311.7,154.6L311.7,154.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_99_",
    cx: 247.171,
    cy: 237.1108,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_99_)",
    d: "M247.2,238.6c1.9,0,1.9-3,0-3S245.2,238.6,247.2,238.6L247.2,238.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_100_",
    cx: 221.6723,
    cy: 289.6082,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_100_)",
    d: "M221.7,291.1c1.9,0,1.9-3,0-3S219.7,291.1,221.7,291.1L221.7,291.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_101_",
    cx: 163.1752,
    cy: 318.1068,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_101_)",
    d: "M163.2,319.6c1.9,0,1.9-3,0-3C161.2,316.6,161.2,319.6,163.2,319.6L163.2,319.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_102_",
    cx: 236.6716,
    cy: 343.6055,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_102_)",
    d: "M236.7,345.1c1.9,0,1.9-3,0-3C234.7,342.1,234.7,345.1,236.7,345.1L236.7,345.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_103_",
    cx: 328.167,
    cy: 303.1075,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_103_)",
    d: "M328.2,304.6c1.9,0,1.9-3,0-3S326.2,304.6,328.2,304.6L328.2,304.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_104_",
    cx: 304.1682,
    cy: 265.6094,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_104_)",
    d: "M304.2,267.1c1.9,0,1.9-3,0-3S302.2,267.1,304.2,267.1L304.2,267.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_105_",
    cx: 493.1588,
    cy: 214.612,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_105_)",
    d: "M493.2,216.1c1.9,0,1.9-3,0-3C491.2,213.1,491.2,216.1,493.2,216.1L493.2,216.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_106_",
    cx: 527.657,
    cy: 99.1177,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_106_)",
    d: "M527.7,100.6c1.9,0,1.9-3,0-3C525.7,97.6,525.7,100.6,527.7,100.6L527.7,100.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_107_",
    cx: 466.1601,
    cy: 171.1142,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_107_)",
    d: "M466.2,172.6c1.9,0,1.9-3,0-3S464.2,172.6,466.2,172.6L466.2,172.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_108_",
    cx: 404.6632,
    cy: 210.1122,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_108_)",
    d: "M404.7,211.6c1.9,0,1.9-3,0-3C402.7,208.6,402.7,211.6,404.7,211.6L404.7,211.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_109_",
    cx: 430.1619,
    cy: 219.1117,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_109_)",
    d: "M430.2,220.6c1.9,0,1.9-3,0-3S428.2,220.6,430.2,220.6L430.2,220.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_110_",
    cx: 472.1598,
    cy: 255.1099,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_110_)",
    d: "M472.2,256.6c1.9,0,1.9-3,0-3S470.2,256.6,472.2,256.6L472.2,256.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_111_",
    cx: 613.1527,
    cy: 207.1124,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_111_)",
    d: "M613.2,208.6c1.9,0,1.9-3,0-3C611.2,205.6,611.2,208.6,613.2,208.6L613.2,208.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_112_",
    cx: 542.6563,
    cy: 172.6141,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_112_)",
    d: "M542.7,174.1c1.9,0,1.9-3,0-3C540.7,171.1,540.7,174.1,542.7,174.1L542.7,174.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_113_",
    cx: 659.6504,
    cy: 127.6163,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_113_)",
    d: "M659.7,129.1c1.9,0,1.9-3,0-3C657.7,126.1,657.7,129.1,659.7,129.1L659.7,129.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_114_",
    cx: 688.149,
    cy: 81.1186,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_114_)",
    d: "M688.1,82.6c1.9,0,1.9-3,0-3S686.2,82.6,688.1,82.6L688.1,82.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_115_",
    cx: 716.6476,
    cy: 16.6219,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_115_)",
    d: "M716.6,18.1c1.9,0,1.9-3,0-3C714.7,15.1,714.7,18.1,716.6,18.1L716.6,18.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_116_",
    cx: 823.1422,
    cy: 19.6217,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_116_)",
    d: "M823.1,21.1c1.9,0,1.9-3,0-3C821.2,18.1,821.2,21.1,823.1,21.1L823.1,21.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_117_",
    cx: 754.1457,
    cy: 108.1173,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_117_)",
    d: "M754.1,109.6c1.9,0,1.9-3,0-3S752.2,109.6,754.1,109.6L754.1,109.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_118_",
    cx: 805.1431,
    cy: 178.6138,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_118_)",
    d: "M805.1,180.1c1.9,0,1.9-3,0-3C803.2,177.1,803.2,180.1,805.1,180.1L805.1,180.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_119_",
    cx: 805.1431,
    cy: 268.6093,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_119_)",
    d: "M805.1,270.1c1.9,0,1.9-3,0-3C803.2,267.1,803.2,270.1,805.1,270.1L805.1,270.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_120_",
    cx: 727.147,
    cy: 225.1115,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_120_)",
    d: "M727.1,226.6c1.9,0,1.9-3,0-3C725.2,223.6,725.2,226.6,727.1,226.6L727.1,226.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_121_",
    cx: 767.645,
    cy: 222.1116,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_121_)",
    d: "M767.6,223.6c1.9,0,1.9-3,0-3C765.7,220.6,765.7,223.6,767.6,223.6L767.6,223.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_122_",
    cx: 698.6484,
    cy: 298.6078,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_122_)",
    d: "M698.6,300.1c1.9,0,1.9-3,0-3C696.7,297.1,696.7,300.1,698.6,300.1L698.6,300.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_123_",
    cx: 599.6534,
    cy: 166.6144,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_123_)",
    d: "M599.7,168.1c1.9,0,1.9-3,0-3C597.7,165.1,597.7,168.1,599.7,168.1L599.7,168.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_124_",
    cx: 566.6551,
    cy: 142.6156,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_124_)",
    d: "M566.7,144.1c1.9,0,1.9-3,0-3C564.7,141.1,564.7,144.1,566.7,144.1L566.7,144.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_125_",
    cx: 455.6606,
    cy: 64.6195,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_125_)",
    d: "M455.7,66.1c1.9,0,1.9-3,0-3S453.7,66.1,455.7,66.1L455.7,66.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_126_",
    cx: 398.6635,
    cy: 22.6216,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_126_)",
    d: "M398.7,24.1c1.9,0,1.9-3,0-3C396.7,21.1,396.7,24.1,398.7,24.1L398.7,24.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_127_",
    cx: 518.6575,
    cy: 6.1224,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_127_)",
    d: "M518.7,7.6c1.9,0,1.9-3,0-3C516.7,4.6,516.7,7.6,518.7,7.6L518.7,7.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_128_",
    cx: 515.6576,
    cy: 45.1204,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_128_)",
    d: "M515.7,46.6c1.9,0,1.9-3,0-3C513.7,43.6,513.7,46.6,515.7,46.6L515.7,46.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_129_",
    cx: 559.1555,
    cy: 73.619,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_129_)",
    d: "M559.2,75.1c1.9,0,1.9-3,0-3C557.2,72.1,557.2,75.1,559.2,75.1L559.2,75.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_130_",
    cx: 701.6483,
    cy: 126.1164,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_130_)",
    d: "M701.6,127.6c1.9,0,1.9-3,0-3S699.7,127.6,701.6,127.6L701.6,127.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_131_",
    cx: 749.6459,
    cy: 70.6192,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_131_)",
    d: "M749.6,73.1c3.2,0,3.2-5,0-5C746.4,68.1,746.4,73.1,749.6,73.1L749.6,73.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_132_",
    cx: 818.6425,
    cy: 70.6192,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_132_)",
    d: "M818.6,73.1c3.2,0,3.2-5,0-5C815.4,68.1,815.4,73.1,818.6,73.1L818.6,73.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_133_",
    cx: 760.1454,
    cy: 24.1215,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_133_)",
    d: "M760.1,26.6c3.2,0,3.2-5,0-5S756.9,26.6,760.1,26.6L760.1,26.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_134_",
    cx: 572.6548,
    cy: 21.1216,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_134_)",
    d: "M572.7,23.6c3.2,0,3.2-5,0-5C569.4,18.6,569.4,23.6,572.7,23.6L572.7,23.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_135_",
    cx: 643.1512,
    cy: 21.1216,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_135_)",
    d: "M643.2,23.6c3.2,0,3.2-5,0-5S639.9,23.6,643.2,23.6L643.2,23.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_136_",
    cx: 611.6528,
    cy: 45.1204,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_136_)",
    d: "M611.7,47.6c3.2,0,3.2-5,0-5C608.4,42.6,608.4,47.6,611.7,47.6L611.7,47.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_137_",
    cx: 689.6489,
    cy: 196.6129,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_137_)",
    d: "M689.6,199.1c3.2,0,3.2-5,0-5C686.4,194.1,686.4,199.1,689.6,199.1L689.6,199.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_138_",
    cx: 628.152,
    cy: 166.6144,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_138_)",
    d: "M628.2,169.1c3.2,0,3.2-5,0-5C624.9,164.1,624.9,169.1,628.2,169.1L628.2,169.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_139_",
    cx: 640.1514,
    cy: 271.6091,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_139_)",
    d: "M640.2,274.1c3.2,0,3.2-5,0-5C636.9,269.1,636.9,274.1,640.2,274.1L640.2,274.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_140_",
    cx: 551.6558,
    cy: 247.6103,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_140_)",
    d: "M551.7,250.1c3.2,0,3.2-5,0-5C548.4,245.1,548.4,250.1,551.7,250.1L551.7,250.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_141_",
    cx: 772.1448,
    cy: 181.6136,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_141_)",
    d: "M772.1,184.1c3.2,0,3.2-5,0-5C768.9,179.1,768.9,184.1,772.1,184.1L772.1,184.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_142_",
    cx: 820.1424,
    cy: 312.1071,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_142_)",
    d: "M820.1,314.6c3.2,0,3.2-5,0-5S816.9,314.6,820.1,314.6L820.1,314.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_143_",
    cx: 760.1454,
    cy: 310.6072,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_143_)",
    d: "M760.1,313.1c3.2,0,3.2-5,0-5S756.9,313.1,760.1,313.1L760.1,313.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_144_",
    cx: 679.1494,
    cy: 246.1104,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_144_)",
    d: "M679.1,248.6c3.2,0,3.2-5,0-5C675.9,243.6,675.9,248.6,679.1,248.6L679.1,248.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_145_",
    cx: 397.1635,
    cy: 99.1177,
    r: 2.4595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_145_)",
    d: "M397.2,101.6c3.2,0,3.2-5,0-5S393.9,101.6,397.2,101.6L397.2,101.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_146_",
    cx: 385.1642,
    cy: 96.1179,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_146_)",
    d: "M385.2,97.6c1.9,0,1.9-3,0-3C383.2,94.6,383.2,97.6,385.2,97.6L385.2,97.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_147_",
    cx: 445.1611,
    cy: 106.6174,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_147_)",
    d: "M445.2,108.1c1.9,0,1.9-3,0-3S443.2,108.1,445.2,108.1L445.2,108.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_148_",
    cx: 421.1624,
    cy: 166.6144,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_148_)",
    d: "M421.2,168.1c1.9,0,1.9-3,0-3C419.2,165.1,419.2,168.1,421.2,168.1L421.2,168.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_149_",
    cx: 389.6639,
    cy: 195.1129,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_149_)",
    d: "M389.7,196.6c1.9,0,1.9-3,0-3S387.7,196.6,389.7,196.6L389.7,196.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_150_",
    cx: 361.1653,
    cy: 232.6111,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_150_)",
    d: "M361.2,234.1c1.9,0,1.9-3,0-3S359.2,234.1,361.2,234.1L361.2,234.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_151_",
    cx: 295.1686,
    cy: 237.1108,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_151_)",
    d: "M295.2,238.6c1.9,0,1.9-3,0-3S293.2,238.6,295.2,238.6L295.2,238.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_152_",
    cx: 689.6489,
    cy: 151.6151,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_152_)",
    d: "M689.6,153.1c1.9,0,1.9-3,0-3C687.7,150.1,687.7,153.1,689.6,153.1L689.6,153.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_153_",
    cx: 673.1497,
    cy: 135.116,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_153_)",
    d: "M673.1,136.6c1.9,0,1.9-3,0-3C671.2,133.6,671.2,136.6,673.1,136.6L673.1,136.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_154_",
    cx: 682.1493,
    cy: 106.6174,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_154_)",
    d: "M682.1,108.1c1.9,0,1.9-3,0-3S680.2,108.1,682.1,108.1L682.1,108.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_155_",
    cx: 766.1451,
    cy: 87.1183,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_155_)",
    d: "M766.1,88.6c1.9,0,1.9-3,0-3C764.2,85.6,764.2,88.6,766.1,88.6L766.1,88.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_156_",
    cx: 824.6422,
    cy: 42.1206,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_156_)",
    d: "M824.6,43.6c1.9,0,1.9-3,0-3C822.7,40.6,822.7,43.6,824.6,43.6L824.6,43.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_157_",
    cx: 685.1492,
    cy: 46.6204,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_157_)",
    d: "M685.1,48.1c1.9,0,1.9-3,0-3C683.2,45.1,683.2,48.1,685.1,48.1L685.1,48.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_158_",
    cx: 821.6423,
    cy: 135.116,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_158_)",
    d: "M821.6,136.6c1.9,0,1.9-3,0-3C819.7,133.6,819.7,136.6,821.6,136.6L821.6,136.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_159_",
    cx: 761.6453,
    cy: 138.1158,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_159_)",
    d: "M761.6,139.6c1.9,0,1.9-3,0-3C759.7,136.6,759.7,139.6,761.6,139.6L761.6,139.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_160_",
    cx: 817.1425,
    cy: 226.6114,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_160_)",
    d: "M817.1,228.1c1.9,0,1.9-3,0-3C815.2,225.1,815.2,228.1,817.1,228.1L817.1,228.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_161_",
    cx: 829.142,
    cy: 255.1099,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_161_)",
    d: "M829.1,256.6c1.9,0,1.9-3,0-3C827.2,253.6,827.2,256.6,829.1,256.6L829.1,256.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_162_",
    cx: 778.1445,
    cy: 270.1092,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_162_)",
    d: "M778.1,271.6c1.9,0,1.9-3,0-3C776.2,268.6,776.2,271.6,778.1,271.6L778.1,271.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_163_",
    cx: 776.6446,
    cy: 250.6102,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_163_)",
    d: "M776.6,252.1c1.9,0,1.9-3,0-3C774.7,249.1,774.7,252.1,776.6,252.1L776.6,252.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_164_",
    cx: 797.6435,
    cy: 337.6058,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_164_)",
    d: "M797.6,339.1c1.9,0,1.9-3,0-3C795.7,336.1,795.7,339.1,797.6,339.1L797.6,339.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_165_",
    cx: 727.147,
    cy: 282.1086,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_165_)",
    d: "M727.1,283.6c1.9,0,1.9-3,0-3C725.2,280.6,725.2,283.6,727.1,283.6L727.1,283.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_166_",
    cx: 674.6497,
    cy: 288.1083,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_166_)",
    d: "M674.6,289.6c1.9,0,1.9-3,0-3C672.7,286.6,672.7,289.6,674.6,289.6L674.6,289.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_167_",
    cx: 665.6501,
    cy: 313.607,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_167_)",
    d: "M665.7,315.1c1.9,0,1.9-3,0-3C663.7,312.1,663.7,315.1,665.7,315.1L665.7,315.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_168_",
    cx: 631.1519,
    cy: 288.1083,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_168_)",
    d: "M631.2,289.6c1.9,0,1.9-3,0-3C629.2,286.6,629.2,289.6,631.2,289.6L631.2,289.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_169_",
    cx: 580.1544,
    cy: 307.6073,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_169_)",
    d: "M580.2,309.1c1.9,0,1.9-3,0-3C578.2,306.1,578.2,309.1,580.2,309.1L580.2,309.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_170_",
    cx: 539.6564,
    cy: 285.1085,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_170_)",
    d: "M539.7,286.6c1.9,0,1.9-3,0-3C537.7,283.6,537.7,286.6,539.7,286.6L539.7,286.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_171_",
    cx: 736.1466,
    cy: 355.6049,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_171_)",
    d: "M736.1,357.1c1.9,0,1.9-3,0-3C734.2,354.1,734.2,357.1,736.1,357.1L736.1,357.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_172_",
    cx: 830.6418,
    cy: 358.6048,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_172_)",
    d: "M830.6,360.1c1.9,0,1.9-3,0-3C828.7,357.1,828.7,360.1,830.6,360.1L830.6,360.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_173_",
    cx: 811.1428,
    cy: 382.6036,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_173_)",
    d: "M811.1,384.1c1.9,0,1.9-3,0-3C809.2,381.1,809.2,384.1,811.1,384.1L811.1,384.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_174_",
    cx: 799.1434,
    cy: 309.1072,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_174_)",
    d: "M799.1,310.6c1.9,0,1.9-3,0-3C797.2,307.6,797.2,310.6,799.1,310.6L799.1,310.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_175_",
    cx: 809.6429,
    cy: 328.6063,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_175_)",
    d: "M809.6,330.1c1.9,0,1.9-3,0-3C807.7,327.1,807.7,330.1,809.6,330.1L809.6,330.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_176_",
    cx: 689.6489,
    cy: 268.6093,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_176_)",
    d: "M689.6,270.1c1.9,0,1.9-3,0-3C687.7,267.1,687.7,270.1,689.6,270.1L689.6,270.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_177_",
    cx: 605.6531,
    cy: 229.6112,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_177_)",
    d: "M605.7,231.1c1.9,0,1.9-3,0-3C603.7,228.1,603.7,231.1,605.7,231.1L605.7,231.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_178_",
    cx: 584.6542,
    cy: 190.6132,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_178_)",
    d: "M584.7,192.1c1.9,0,1.9-3,0-3C582.7,189.1,582.7,192.1,584.7,192.1L584.7,192.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_179_",
    cx: 653.6507,
    cy: 213.112,
    r: 3.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_179_)",
    d: "M653.7,216.6c4.5,0,4.5-7,0-7C649.1,209.6,649.1,216.6,653.7,216.6L653.7,216.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_180_",
    cx: 802.1433,
    cy: 132.1161,
    r: 3.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_180_)",
    d: "M802.1,135.6c4.5,0,4.5-7,0-7C797.6,128.6,797.6,135.6,802.1,135.6L802.1,135.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_181_",
    cx: 365.6651,
    cy: 16.6219,
    r: 3.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_181_)",
    d: "M365.7,20.1c4.5,0,4.5-7,0-7C361.2,13.1,361.2,20.1,365.7,20.1L365.7,20.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_182_",
    cx: 424.1622,
    cy: 120.1167,
    r: 3.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_182_)",
    d: "M424.2,123.6c4.5,0,4.5-7,0-7C419.6,116.6,419.6,123.6,424.2,123.6L424.2,123.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_183_",
    cx: 254.6707,
    cy: 157.6148,
    r: 3.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_183_)",
    d: "M254.7,161.1c4.5,0,4.5-7,0-7S250.2,161.1,254.7,161.1L254.7,161.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_184_",
    cx: 200.6734,
    cy: 319.6067,
    r: 3.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_184_)",
    d: "M200.7,323.1c4.5,0,4.5-7,0-7C196.2,316.1,196.2,323.1,200.7,323.1L200.7,323.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_185_",
    cx: 61.1803,
    cy: 148.6153,
    r: 3.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_185_)",
    d: "M61.2,152.1c4.5,0,4.5-7,0-7C56.7,145.1,56.7,152.1,61.2,152.1L61.2,152.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_186_",
    cx: 13.1827,
    cy: 22.6216,
    r: 3.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_186_)",
    d: "M13.2,26.1c4.5,0,4.5-7,0-7S8.7,26.1,13.2,26.1L13.2,26.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_187_",
    cx: 568.155,
    cy: 99.1177,
    r: 3.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_187_)",
    d: "M568.2,102.6c4.5,0,4.5-7,0-7C563.6,95.6,563.6,102.6,568.2,102.6L568.2,102.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_188_",
    cx: 605.6531,
    cy: 103.6175,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_188_)",
    d: "M605.7,105.1c1.9,0,1.9-3,0-3C603.7,102.1,603.7,105.1,605.7,105.1L605.7,105.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_189_",
    cx: 608.653,
    cy: 25.6214,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_189_)",
    d: "M608.7,27.1c1.9,0,1.9-3,0-3C606.7,24.1,606.7,27.1,608.7,27.1L608.7,27.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_190_",
    cx: 727.147,
    cy: 136.6159,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_190_)",
    d: "M727.1,138.1c1.9,0,1.9-3,0-3C725.2,135.1,725.2,138.1,727.1,138.1L727.1,138.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_191_",
    cx: 731.6468,
    cy: 96.1179,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_191_)",
    d: "M731.6,97.6c1.9,0,1.9-3,0-3C729.7,94.6,729.7,97.6,731.6,97.6L731.6,97.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_192_",
    cx: 610.1529,
    cy: 142.6156,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_192_)",
    d: "M610.2,144.1c1.9,0,1.9-3,0-3S608.2,144.1,610.2,144.1L610.2,144.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_193_",
    cx: 554.6556,
    cy: 193.613,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_193_)",
    d: "M554.7,195.1c1.9,0,1.9-3,0-3C552.7,192.1,552.7,195.1,554.7,195.1L554.7,195.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_194_",
    cx: 533.6567,
    cy: 231.1111,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_194_)",
    d: "M533.7,232.6c1.9,0,1.9-3,0-3C531.7,229.6,531.7,232.6,533.7,232.6L533.7,232.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_195_",
    cx: 509.6579,
    cy: 157.6148,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_195_)",
    d: "M509.7,159.1c1.9,0,1.9-3,0-3C507.7,156.1,507.7,159.1,509.7,159.1L509.7,159.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_196_",
    cx: 493.1588,
    cy: 103.6175,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_196_)",
    d: "M493.2,105.1c1.9,0,1.9-3,0-3C491.2,102.1,491.2,105.1,493.2,105.1L493.2,105.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_197_",
    cx: 455.6606,
    cy: 133.616,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_197_)",
    d: "M455.7,135.1c1.9,0,1.9-3,0-3S453.7,135.1,455.7,135.1L455.7,135.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_198_",
    cx: 461.6603,
    cy: 196.6129,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_198_)",
    d: "M461.7,198.1c1.9,0,1.9-3,0-3S459.7,198.1,461.7,198.1L461.7,198.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_199_",
    cx: 407.663,
    cy: 193.613,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_199_)",
    d: "M407.7,195.1c1.9,0,1.9-3,0-3S405.7,195.1,407.7,195.1L407.7,195.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_200_",
    cx: 373.1647,
    cy: 172.6141,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_200_)",
    d: "M373.2,174.1c1.9,0,1.9-3,0-3S371.2,174.1,373.2,174.1L373.2,174.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_201_",
    cx: 317.6675,
    cy: 187.6133,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_201_)",
    d: "M317.7,189.1c1.9,0,1.9-3,0-3S315.7,189.1,317.7,189.1L317.7,189.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_202_",
    cx: 349.166,
    cy: 196.6129,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_202_)",
    d: "M349.2,198.1c1.9,0,1.9-3,0-3C347.2,195.1,347.2,198.1,349.2,198.1L349.2,198.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_203_",
    cx: 287.669,
    cy: 180.1137,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_203_)",
    d: "M287.7,181.6c1.9,0,1.9-3,0-3S285.7,181.6,287.7,181.6L287.7,181.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_204_",
    cx: 263.6702,
    cy: 211.6121,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_204_)",
    d: "M263.7,213.1c1.9,0,1.9-3,0-3C261.7,210.1,261.7,213.1,263.7,213.1L263.7,213.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_205_",
    cx: 278.6695,
    cy: 274.609,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_205_)",
    d: "M278.7,276.1c1.9,0,1.9-3,0-3S276.7,276.1,278.7,276.1L278.7,276.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_206_",
    cx: 248.671,
    cy: 276.1089,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_206_)",
    d: "M248.7,277.6c1.9,0,1.9-3,0-3C246.7,274.6,246.7,277.6,248.7,277.6L248.7,277.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_207_",
    cx: 353.6657,
    cy: 279.1087,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_207_)",
    d: "M353.7,280.6c1.9,0,1.9-3,0-3S351.7,280.6,353.7,280.6L353.7,280.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_208_",
    cx: 329.6669,
    cy: 228.1113,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_208_)",
    d: "M329.7,229.6c1.9,0,1.9-3,0-3C327.7,226.6,327.7,229.6,329.7,229.6L329.7,229.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_209_",
    cx: 356.6656,
    cy: 127.6163,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_209_)",
    d: "M356.7,129.1c1.9,0,1.9-3,0-3S354.7,129.1,356.7,129.1L356.7,129.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_210_",
    cx: 344.6662,
    cy: 157.6148,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_210_)",
    d: "M344.7,159.1c1.9,0,1.9-3,0-3S342.7,159.1,344.7,159.1L344.7,159.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_211_",
    cx: 307.168,
    cy: 114.117,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_211_)",
    d: "M307.2,115.6c1.9,0,1.9-3,0-3S305.2,115.6,307.2,115.6L307.2,115.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_212_",
    cx: 415.1626,
    cy: 55.6199,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_212_)",
    d: "M415.2,57.1c1.9,0,1.9-3,0-3S413.2,57.1,415.2,57.1L415.2,57.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_213_",
    cx: 464.6602,
    cy: 88.6183,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_213_)",
    d: "M464.7,90.1c1.9,0,1.9-3,0-3S462.7,90.1,464.7,90.1L464.7,90.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_214_",
    cx: 524.6572,
    cy: 192.1131,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_214_)",
    d: "M524.7,193.6c1.9,0,1.9-3,0-3S522.7,193.6,524.7,193.6L524.7,193.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_215_",
    cx: 541.1563,
    cy: 120.1167,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_215_)",
    d: "M541.2,121.6c1.9,0,1.9-3,0-3C539.2,118.6,539.2,121.6,541.2,121.6L541.2,121.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_216_",
    cx: 629.6519,
    cy: 238.6108,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_216_)",
    d: "M629.7,240.1c1.9,0,1.9-3,0-3S627.7,240.1,629.7,240.1L629.7,240.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_217_",
    cx: 655.1506,
    cy: 177.1138,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_217_)",
    d: "M655.2,178.6c1.9,0,1.9-3,0-3C653.2,175.6,653.2,178.6,655.2,178.6L655.2,178.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_218_",
    cx: 698.6484,
    cy: 225.1115,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_218_)",
    d: "M698.6,226.6c1.9,0,1.9-3,0-3C696.7,223.6,696.7,226.6,698.6,226.6L698.6,226.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_219_",
    cx: 743.6462,
    cy: 192.1131,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_219_)",
    d: "M743.6,193.6c1.9,0,1.9-3,0-3C741.7,190.6,741.7,193.6,743.6,193.6L743.6,193.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_220_",
    cx: 751.1458,
    cy: 261.1096,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_220_)",
    d: "M751.1,262.6c1.9,0,1.9-3,0-3C749.2,259.6,749.2,262.6,751.1,262.6L751.1,262.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_221_",
    cx: 797.6435,
    cy: 202.6126,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_221_)",
    d: "M797.6,204.1c1.9,0,1.9-3,0-3C795.7,201.1,795.7,204.1,797.6,204.1L797.6,204.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_222_",
    cx: 631.1519,
    cy: 334.606,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_222_)",
    d: "M631.2,336.1c1.9,0,1.9-3,0-3C629.2,333.1,629.2,336.1,631.2,336.1L631.2,336.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_223_",
    cx: 367.165,
    cy: 313.607,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_223_)",
    d: "M367.2,315.1c1.9,0,1.9-3,0-3S365.2,315.1,367.2,315.1L367.2,315.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_224_",
    cx: 296.6686,
    cy: 331.6061,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_224_)",
    d: "M296.7,333.1c1.9,0,1.9-3,0-3C294.7,330.1,294.7,333.1,296.7,333.1L296.7,333.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_225_",
    cx: 214.1727,
    cy: 249.1102,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_225_)",
    d: "M214.2,250.6c1.9,0,1.9-3,0-3C212.2,247.6,212.2,250.6,214.2,250.6L214.2,250.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_226_",
    cx: 188.674,
    cy: 171.1142,
    r: 1.4757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1459,
    style: {
      stopColor: "#E62A7A",
      stopOpacity: 0.8978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#D82B76",
      stopOpacity: 0.8072
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3987,
    style: {
      stopColor: "#C52C71",
      stopOpacity: 0.7209
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    style: {
      stopColor: "#AB2C69",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6348,
    style: {
      stopColor: "#8C2B60",
      stopOpacity: 0.5556
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7495,
    style: {
      stopColor: "#6A2755",
      stopOpacity: 0.4753
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8625,
    style: {
      stopColor: "#452147",
      stopOpacity: 0.3962
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    style: {
      stopColor: "#1A1738",
      stopOpacity: 0.3199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0.3
    }
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_226_)",
    d: "M188.7,172.6c1.9,0,1.9-3,0-3S186.7,172.6,188.7,172.6L188.7,172.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_227_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.1983,
    y1: 398.8711,
    x2: 571.5207,
    y2: 102.5487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_227_)",
    cx: 420.9,
    cy: 253.1,
    r: 183.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_228_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.7982,
    y1: 333.2414,
    x2: 380.7982,
    y2: -4.7586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433"
    }
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_228_)",
    d: "M250.2,319.6L296,208.7c0,0-14,64.3,12,44.5c17.5-13.4,62.5-116,90.1-181.7 c-9,1.1-17.7,2.9-26.2,5.2C345.8,132.1,311,199.9,311,199.9s12-74.9-16-24.6c-18.6,33.4-40.7,84.4-53.4,114.9 C243.6,300.4,246.5,310.1,250.2,319.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_229_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.8831,
    y1: 359.5415,
    x2: 460.8831,
    y2: 21.5415
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433"
    }
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_229_)",
    d: "M340.1,417.5c17.9-53.8,58.6-171.3,85.9-217.6c26.6-45.1,60.9-90.2,77-110.6 c-3.4-1.7-6.9-3.3-10.5-4.9c-18.8,32.4-50.5,84.3-61.5,86.9c-11.6,2.7,21.1-60,39.8-94.5c-5.6-1.6-11.3-2.9-17.1-4 c-5.8,19.9-13,41.5-17.7,44.1c-5.1,2.8-0.8-23.2,3.8-46.1c-3.5-0.4-7.1-0.6-10.7-0.8C418.7,116.4,398.3,199.8,380,233 c-18.4,33.3-70,101.8-98.5,138.9c2.4,2.8,4.8,5.5,7.4,8.1c17.3-24.4,40.5-54.8,52.1-60c14-6.3-6.8,51.2-20.6,86.2 C326.7,410.4,333.3,414.2,340.1,417.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_230_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.1429,
    y1: 388.1978,
    x2: 548.1429,
    y2: 50.1978
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433"
    }
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_230_)",
    d: "M436.2,435.7c9.8-52.5,31.3-160.8,49.8-207.7c17.2-43.4,44-86.9,58.9-109.7 c-5.8-5.3-11.9-10.3-18.3-14.8c-15.2,33.6-66.1,147.7-82.9,207.2c-12.6,44.6-22.3,94.7-27.8,125.5c1.7,0,3.3,0.1,5,0.1 C426.1,436.3,431.1,436.1,436.2,435.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_231_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.4626,
    y1: 373.8531,
    x2: 504.4626,
    y2: 35.8531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433"
    }
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_231_)",
    d: "M439,228c-10.9,6.2-56.1,139.7-75.8,199c7.7,2.5,15.5,4.6,23.6,6.1 C406.9,366.9,449.8,221.8,439,228z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_232_",
    gradientUnits: "userSpaceOnUse",
    x1: 500.7541,
    y1: 409.0879,
    x2: 611.7541,
    y2: 71.0879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433"
    }
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_232_)",
    d: "M537,394.8c4.9-58.9,16.2-167.7,38.1-240.7c-4.6-7.2-9.8-14.1-15.4-20.5 c-14.3,51.2-42.1,148-60.7,198.6c-15.8,43-27.5,78-34.3,98.8c8.2-2,16.2-4.6,24-7.7c8.5-35.1,25.7-101.8,37.3-116.3 c11.6-14.5-1,59.9-8.8,101.9C524.1,404.7,530.7,400,537,394.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_233_",
    gradientUnits: "userSpaceOnUse",
    x1: 535.6841,
    y1: 420.559,
    x2: 646.6841,
    y2: 82.559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433"
    }
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_233_)",
    d: "M596.5,200.8c-6.8,27.2-16.1,66.8-18.5,89.4c-2.3,21,12.7-11.4,26-43 C603.5,231.1,600.9,215.5,596.5,200.8z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_234_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.945,
    y1: 474.099,
    x2: 420.945,
    y2: 634.6159
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_234_)",
    points: "0,492.9 77,485.3 101.7,492.9 171.7,489.1 184.3,492.9 199.7,485.3 224.3,489.1  229.7,492.9 296.3,489.1 325,492.9 361.7,485.3 366.9,477.6 378.3,481.4 383.7,489.1 509,497.5 527,492.1 532.3,493.7 593,481.4  603,492.1 687,497.5 706.3,492.9 739,487.5 746.3,492.9 759.7,487.5 769,492.9 841.9,487.5 841.9,595.3 0,595.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_235_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.945,
    y1: 601.4749,
    x2: 420.945,
    y2: 376.6038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000018"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1064,
    style: {
      stopColor: "#00001B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2318,
    style: {
      stopColor: "#090022"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3667,
    style: {
      stopColor: "#20082D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    style: {
      stopColor: "#3B143A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6555,
    style: {
      stopColor: "#5D1E4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    style: {
      stopColor: "#8F275D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9593,
    style: {
      stopColor: "#D22A73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE2A7B"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_235_)",
    points: "769,499 759.7,494 746.3,499 739,494 706.3,499 687,503.3 655.2,513 700.1,522 664.2,522  601.1,535.5 563,536.4 676.7,545 541.1,555 554.7,559 491.7,572 355.1,572 365.7,566 258.1,556 311,545 286.2,545 271,536.4  278.7,527 207.3,517 241.6,508 200.7,499 184.3,499 171.7,495.4 101.7,499 77,491.8 0,499 0,595.3 841.9,595.3 841.9,494  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_236_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.8571,
    y1: 512.7211,
    x2: 439.8571,
    y2: 498.6953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000018"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_236_)",
    points: "398.1,499 365.7,502.3 392.2,506 456,509 448,512.5 499.5,508.5 514,505.8 461.1,502.3  "
  })), /*#__PURE__*/React.createElement("g", null, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE2A7B",
    d: "M376.9,386.9c1,1,4.3,2.2,4.3,2.2l3.3,4.5c0,0,1.3,8.8,2.8,10.8c1.5,2,5.5,2.4,5.5,2.4s-6,28-5.5,29.3 c0.5,1.3,0,7.8,0,7.8s-5.8,15.8-5.8,18.2c0,2.4,3.7,6.1,3.7,6.1s-5.3,21.9-5,23.3c0.3,1.3,2.3,3.4,2.3,3.4s-1.4,3.3-1.9,7.6H400 l4-14c0,0,2.7-1.7,3.3-5.1s3.3-16.2,3.3-16.2l5-14.5l5.3-28.6l5.3,28.6l5,14.5c0,0,2.7,12.8,3.3,16.2c0.7,3.4,3.3,5.1,3.3,5.1 l4,14h19.2c-0.4-4.3-1.9-7.6-1.9-7.6s2-2,2.3-3.4c0.3-1.3-5-23.3-5-23.3s3.7-3.7,3.7-6.1c0-2.4-5.8-18.2-5.8-18.2s-0.5-6.4,0-7.8 c0.5-1.3-5.5-29.3-5.5-29.3s4-0.3,5.5-2.4c1.5-2,2.8-10.8,2.8-10.8l3.3-4.5c0,0,3.3-1.2,4.3-2.2c1-1,0.7-3,0.7-3s12-9.8,12-13.8 c0-4-7-20.9-7-20.9s0-4,0-5.7c0-1.7-9.7-13.5-9.7-13.5l-2.3-9.8l-8.7-1.9l-2.5-8.2h-2.5c1.4-3.2,2.2-6.8,2.2-10.6 c0-14.6-11.7-26.5-26.2-26.5c-14.5,0-26.2,11.8-26.2,26.5c0,3.8,0.8,7.4,2.2,10.6h-2.5l-2.5,8.2l-8.7,1.9l-2.3,9.8 c0,0-9.7,11.8-9.7,13.5c0,1.7,0,5.7,0,5.7s-7,16.8-7,20.9c0,4,12,13.8,12,13.8S375.9,385.8,376.9,386.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_237_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.945,
    y1: 585.0934,
    x2: 420.945,
    y2: 340.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000018"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433"
    }
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_237_)",
    d: "M469.5,352.3c-0.6,0.2-1.1,0.3-1.4,0.3c-0.7,0-2.8-0.8-2.8-0.8s1.5-0.1,2.1-0.2 c0.3-0.1,1-0.3,1.7-0.6c-0.2-0.6-0.4-1-0.5-1.4c-1,0-2.4-0.1-3-0.3c-0.9-0.3-3.1-2.3-3.1-2.3s1.9,0.6,2.7,0.7 c0.5,0.1,2.1,0.1,3.2,0c0-1.3,0-3.2,0-4.2c0-1.3-6-9.2-8.3-12.1l-6.5,2.7l5.3-5.1l-1.9-8.4l-8.3-1.9l-2.4-8h-2.4 c1.3-3.2,2.1-6.7,2.1-10.4c0-14.4-11.2-26-24.9-26s-24.9,11.6-24.9,26c0,3.7,0.8,7.2,2.1,10.4h-2.4l-2.4,8l-8.3,1.9l-1.9,8.4 l5.3,5.1l-6.5-2.7c-2.3,2.9-8.3,10.8-8.3,12.1c0,1,0,2.9,0,4.2c1.1,0,2.8,0,3.2,0c0.8-0.1,2.7-0.7,2.7-0.7s-2.2,2-3.1,2.3 c-0.6,0.2-1.9,0.3-3,0.3c-0.1,0.3-0.3,0.8-0.5,1.4c0.7,0.3,1.4,0.5,1.7,0.6c0.6,0.1,2.1,0.2,2.1,0.2s-2.1,0.8-2.8,0.8 c-0.3,0-0.9-0.2-1.4-0.3c-1.9,5-5.5,14.6-5.5,17.5c0,2.8,5.8,8.5,9.1,11.6l10.9,1.2c0,0-2.3,0.6-4.2,0.8c-1.9,0.2-4.5,0-4.5,0 s-0.3,2,0.6,3c1,1,4.1,2.2,4.1,2.2l3.1,4.3l3.2-1.7l-2.7,3.9c0.5,2.7,1.4,7.2,2.4,8.6c1.4,2,5.2,2.3,5.2,2.3s-5.7,27.5-5.2,28.8 c0.3,0.9,0.2,4.1,0.1,6l4.4-1.7l-4.7,3.8c-1,2.7-5.4,15.3-5.4,17.4c0,0.1,0,0.2,0,0.2l3.2-1.1L384,462c0.4,0.9,1.1,1.8,1.6,2.6 l4.3-2.1l-2.9,3.7c0,0-5.1,21.5-4.8,22.9c0.1,0.6,0.7,1.4,1.1,2c0.8-0.3,1.9-0.8,2.2-1.1c0.4-0.3,2.5-2.4,2.5-2.4 s-1.3,3.2-1.9,3.7c-0.4,0.3-1.2,0.8-1.7,1c0,0,0,0,0,0s-1.9,4.6-1.9,9.9h17.8l4.4-16.2c0,0,2.5-1.7,3.2-5s3.2-15.9,3.2-15.9 l4.8-14.3l5.1-28.2l5.1,28.2l4.8,14.3c0,0,2.5,12.6,3.2,15.9s3.2,5,3.2,5l4.4,16.2h17.8c0-5.3-1.9-9.9-1.9-9.9s0,0,0,0 c-0.6-0.3-1.4-0.7-1.7-1c-0.6-0.5-1.9-3.7-1.9-3.7s2,2.1,2.5,2.4c0.3,0.2,1.4,0.7,2.2,1.1c0.5-0.6,1-1.4,1.1-2 c0.3-1.3-4.8-22.9-4.8-22.9l-2.9-3.7l4.3,2.1c0.6-0.7,1.2-1.7,1.6-2.6l-2.7-2.7l3.2,1.1c0-0.1,0-0.2,0-0.2 c0-2.1-4.4-14.6-5.4-17.4l-4.7-3.8l4.4,1.7c-0.1-2-0.2-5.1,0.1-6c0.5-1.3-5.2-28.8-5.2-28.8s3.8-0.3,5.2-2.3 c1-1.4,1.9-5.9,2.4-8.6l-2.7-3.9l3.2,1.7l3.1-4.3c0,0,3.2-1.2,4.1-2.2c1-1,0.6-3,0.6-3s-2.6,0.2-4.5,0c-1.9-0.2-4.2-0.8-4.2-0.8 l10.9-1.2c3.3-3,9.1-8.7,9.1-11.6C474.9,366.8,471.4,357.2,469.5,352.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_238_",
    gradientUnits: "userSpaceOnUse",
    x1: 503.687,
    y1: -117.3167,
    x2: 573.6882,
    y2: -117.3167,
    gradientTransform: "matrix(1.5283 -1.5283 0.3744 0.3744 -73.32 1025.8191)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2648,
    style: {
      stopColor: "#A12C66",
      stopOpacity: 0.7352
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7753,
    style: {
      stopColor: "#381E42",
      stopOpacity: 0.2247
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0
    }
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_238_)",
    d: "M778.9,85.8c1.2,1.2-110.3,114.7-115.2,119.6c-4.9,4.9-9.9,8-11.1,6.7c-1.2-1.2,1.8-6.2,6.7-11.1 C664.2,196.1,777.6,84.6,778.9,85.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_239_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.4334,
    y1: -637.4749,
    x2: 367.4346,
    y2: -637.4749,
    gradientTransform: "matrix(1.5283 -1.5283 0.3744 0.3744 -73.32 1025.8191)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2648,
    style: {
      stopColor: "#A12C66",
      stopOpacity: 0.7352
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7753,
    style: {
      stopColor: "#381E42",
      stopOpacity: 0.2247
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0
    }
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_239_)",
    d: "M268.9,206.2c1.2,1.2-110.3,114.7-115.2,119.6s-9.9,8-11.1,6.7c-1.2-1.2,1.8-6.2,6.7-11.1 S267.7,205,268.9,206.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_240_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.1271,
    y1: -10.693,
    x2: 553.1284,
    y2: -10.693,
    gradientTransform: "matrix(2.4871 -2.4871 0.3744 0.3744 -621.4477 1573.9467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2648,
    style: {
      stopColor: "#A12C66",
      stopOpacity: 0.7352
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7753,
    style: {
      stopColor: "#381E42",
      stopOpacity: 0.2247
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0
    }
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_240_)",
    d: "M781.8,162.7C783,163.9,600.9,348,592.9,356s-15.5,13.6-16.7,12.3c-1.2-1.2,4.3-8.7,12.3-16.7 C596.5,343.6,780.6,161.5,781.8,162.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_241_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.5316,
    y1: -884.5016,
    x2: 366.0352,
    y2: -884.5016,
    gradientTransform: "matrix(1.5283 -1.5283 0.3744 0.3744 -73.32 1025.8191)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2648,
    style: {
      stopColor: "#A12C66",
      stopOpacity: 0.7352
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7753,
    style: {
      stopColor: "#381E42",
      stopOpacity: 0.2247
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0
    }
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_241_)",
    d: "M165.5,124.6c0.7,0.7-60.7,63.1-63.4,65.8s-5.5,4.4-6.1,3.7c-0.7-0.7,1-3.4,3.7-6.1 S164.9,123.9,165.5,124.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_242_",
    gradientUnits: "userSpaceOnUse",
    x1: 512.2706,
    y1: 91.5213,
    x2: 550.7742,
    y2: 91.5213,
    gradientTransform: "matrix(1.5283 -1.5283 0.3744 0.3744 -73.32 1025.8191)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2648,
    style: {
      stopColor: "#A12C66",
      stopOpacity: 0.7352
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7753,
    style: {
      stopColor: "#381E42",
      stopOpacity: 0.2247
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0
    }
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_242_)",
    d: "M813.3,207.7c0.7,0.7-60.7,63.1-63.4,65.8c-2.7,2.7-5.5,4.4-6.1,3.7c-0.7-0.7,1-3.4,3.7-6.1 C750.3,268.4,812.7,207,813.3,207.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_243_",
    gradientUnits: "userSpaceOnUse",
    x1: 518.1594,
    y1: -373.1555,
    x2: 556.663,
    y2: -373.1555,
    gradientTransform: "matrix(1.5283 -1.5283 0.3744 0.3744 -73.32 1025.8191)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2648,
    style: {
      stopColor: "#A12C66",
      stopOpacity: 0.7352
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7753,
    style: {
      stopColor: "#381E42",
      stopOpacity: 0.2247
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0
    }
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_243_)",
    d: "M648.3,24.7c0.7,0.7-60.7,63.1-63.4,65.8c-2.7,2.7-5.5,4.4-6.1,3.7c-0.7-0.7,1-3.4,3.7-6.1 C585.3,85.4,647.7,24.1,648.3,24.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_244_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.5152,
    y1: -790.4296,
    x2: 441.0188,
    y2: -790.4296,
    gradientTransform: "matrix(3.1621 -3.1621 0.3744 0.3744 -812.7663 1765.2653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2648,
    style: {
      stopColor: "#A12C66",
      stopOpacity: 0.7352
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7753,
    style: {
      stopColor: "#381E42",
      stopOpacity: 0.2247
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0
    }
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_244_)",
    d: "M307.8,52.7c0.7,0.7-126.8,129.2-132.4,134.8c-5.6,5.6-10.7,9.6-11.4,9c-0.7-0.7,3.3-5.8,9-11.4 C178.6,179.5,307.2,52.1,307.8,52.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_245_",
    gradientUnits: "userSpaceOnUse",
    x1: 375.08,
    y1: -920.4284,
    x2: 413.5836,
    y2: -920.4284,
    gradientTransform: "matrix(3.1621 -3.1621 0.3744 0.3744 -812.7663 1765.2653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2A7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2648,
    style: {
      stopColor: "#A12C66",
      stopOpacity: 0.7352
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7753,
    style: {
      stopColor: "#381E42",
      stopOpacity: 0.2247
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#091433",
      stopOpacity: 0
    }
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_245_)",
    d: "M172.4,90.8C173.1,91.5,45.6,220,40,225.6c-5.6,5.6-10.7,9.6-11.4,9c-0.7-0.7,3.3-5.8,9-11.4 S171.8,90.1,172.4,90.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlonehere);
export default __webpack_public_path__ + "static/media/alonehere.824b4e61801138072b3aa5cbf0764229.svg";
export { ForwardRef as ReactComponent };